import { CREDITS_ENGINE_API } from '../env';

// Catálogo de planes para la página de precios PRE-LOGIN -- a diferencia
// de todo lo demás en CreditsEngineService.js, esta ruta es explícitamente
// pública (Auth: Authorizer NONE en whisperbi-credits-engine/template.yaml,
// GET /public/subscription-plans): sin fetchAuthSession, sin Bearer token,
// puede llamarse sin que el visitante tenga cuenta.
const API_BASE = CREDITS_ENGINE_API;
const PUBLIC_PLANS_URL = `${API_BASE}/public/subscription-plans`;

const PublicPlansService = {
  async listPlans() {
    let response;
    try {
      response = await fetch(PUBLIC_PLANS_URL, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        mode: 'cors',
        cache: 'no-cache'
      });
    } catch (networkError) {
      throw new Error(`No se pudo obtener el catálogo de planes. ${networkError.message}`);
    }

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data?.plans) ? data.plans : [];
  }
};

export default PublicPlansService;
